var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin2020 = function SvgPin2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    d: "M10 1.25c-3.455 0-6.25 2.739-6.25 6.125 0 3.926 4.566 9.45 5.893 10.973a.47.47 0 0 0 .714 0c1.327-1.522 5.893-7.047 5.893-10.973 0-3.386-2.795-6.125-6.25-6.125m0 8.313c-1.232 0-2.232-.98-2.232-2.188 0-1.207 1-2.187 2.232-2.187s2.232.98 2.232 2.187-1 2.188-2.232 2.188"
  })));
};
export default SvgPin2020;